import { useCallback } from "react";
import Environment from "../../utils/Environment";
import { PRICE_API_URL } from "../../utils/ApiUrl";

const EthPrice = () => {
  const priceSymbol = "ETH";

  const buildHeaders = () => ({
    "X-API-Key": Environment.PRICE_KEY,
    "Content-Type": "application/json",
  });

  const ethPrice = useCallback(async () => {
    try {
      const res = await fetch(
        `${PRICE_API_URL}/api/v1/markets/${encodeURIComponent(priceSymbol)}/price`,
        { headers: buildHeaders() },
      );

      const data = await res.json();
      return data?.price ?? 0;
    } catch (error) {
      throw error;
    }
  }, []);

  return { ethPrice };
};

export default EthPrice;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import {
//   chinaContract,
//   tokenRegistryContract,
// } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";
// import Web3 from "web3";

// const EthPrice = () => {
//   const [balance, setBalance] = useState(null);
//   const { account, chainId } = useWeb3React();
//   // const web3 = useWeb3();
//   const web3 = new Web3(Environment.rpc);
//   const address = Environment.weth; //////// WETH ADDRESS //////
//   const tokenAddress = Environment.tokenRegistry;
//   const contract = tokenRegistryContract(tokenAddress, web3);

//   const ethPrice = useCallback(async () => {
//     try {
//       const buy = await contract.methods.getLatestPrice(address).call();
//       console.log(buy, "Buy");
//       // console.log(buy[0]/10**8,"buy");
//       return buy[0] / 10 ** 8;
//     } catch (error) {
//       throw error;
//     }
//   }, [contract, account, web3]);
//   return { ethPrice: ethPrice };
// };
// export default EthPrice;
